import type { Metadata } from "next";
import AdminUserEdit from "@/Component/Common/AdminUserEdit";

export const metadata: Metadata = {
    title: "Edit Brand | Connector Club",
    description: "",
};

const AdminBrandEditPage = async ({ params }: { params: Promise<{ UserSlug: string }>; }) => {
    const resolvedParams = await params;
    const userSlug = resolvedParams.UserSlug;
    
    return <AdminUserEdit userSlug={userSlug} />;
};

export default AdminBrandEditPage;
